const LINK_BEHAVIOR = {
  SAME_TAB: 'same_tab',
  NEW_TAB: 'new_tab',
  NEW_WINDOW: 'new_window',
  FUNCTION: 'function',
};

const MODULES = {
  HIGHLIGHT: 'Highlight',
  ADVERTISEMENTS: 'Advertisements',
  BANNER: 'Banner',
  RESOURCES: 'Resources',
  HIRED_PRODUCTS: 'HiredProducts',
};

const RESOURCES_ELEMENTS = {
  RESOURCES: 'Resources',
  CARD_RESOURCE_IMAGE: 'CardResourceImage',
  CARD_RESOURCE: 'CardResource',
};

const PRODUCTS_HIGHLIGHT_IDS = {
  SITE_CREATOR: 2,
  EMAIL_TITAN: 3,
  LINK_BIO: 4,
  HG_STUDIO_PRO_TRIAL: 12,
  HG_STUDIO_PRO: 13,
  HG_STUDIO_FREE: 14,
};

const ALL_STUDIO_HIGHLIGHTS_IDS = [
  PRODUCTS_HIGHLIGHT_IDS.HG_STUDIO_PRO_TRIAL,
  PRODUCTS_HIGHLIGHT_IDS.HG_STUDIO_PRO,
  PRODUCTS_HIGHLIGHT_IDS.HG_STUDIO_FREE,
];

export {
  LINK_BEHAVIOR,
  MODULES,
  RESOURCES_ELEMENTS,
  PRODUCTS_HIGHLIGHT_IDS,
  ALL_STUDIO_HIGHLIGHTS_IDS,
};
